import React from "react";
import { Tabs, Tab, styled } from "@mui/material";
import { ColorsV2 } from "app/constants/color";

const StyledTab = styled(Tab)({
    backgroundColor: ColorsV2.primary,
    color: ColorsV2.textInfo,
    "&.Mui-selected": {
        color: ColorsV2.white,
        backgroundColor: ColorsV2.secondary,
    },
});

/**
 * PageTabs Component
 *
 * A pre-styled MUI Tabs wrapper.
 * 
 * Props:
 * - value (number): Selected tab.
 * - onChange (function): Tab change handler.
 * - tabs (array): Tab list [{ value, label, props? }] (default: fallback tab).
 * - indicatorColor (string, optional): Custom indicator color.
 * - indicatorPlacement (string, optional): 'top' or bottom.
 * 
 * Fallback tab prevents crashes on invalid input.
 */

const PageTabs = ({ value, onChange, tabs = [{ value: 0, label: "Error loading tabs" }], indicatorColor = null, indicatorPlacement = null, ...tabProps }) => {
  return (
    <Tabs value={value} onChange={onChange} {...tabProps} sx={{
        "& .MuiTabs-indicator": { 
            backgroundColor: indicatorColor || 'transparent',
            marginTop: '2px',
            top: indicatorPlacement === 'top' ? 0 : 'unset',
            bottom: indicatorPlacement === 'top' ? 'unset' : 0,
        },
      }}>
      {tabs.map(
        (tab, index) =>
          tab.value !== undefined &&
          tab.label && (
            <StyledTab
              key={index}
              value={tab.value}
              label={tab.label}
              {...tab?.props}
              sx={{
                borderTopLeftRadius: index === 0 ? '4px' : '0px',
                borderTopRightRadius: index === tabs?.length - 1 ? '4px' : '0px', 
                ...tab.props?.sx,
              }}
            />
          )
      )}
    </Tabs>
  );
};

export default PageTabs;
